module.exports = __webpack_public_path__ + "static/img/no2.3254d6e0.png";